import React from 'react'
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { DateLabel, DateHourLabel } from '../Labels';
import lodashTruncate from '../../utils/lodashTruncate';
import ColCheckBox from './ColCheckBox';
import { StatusConciliation } from "../../components";

const ItemCell = ( { valueCol } ) => {

  let TextCol = '';
  let propriedade = {};
	const maxLengthDefault = 20;
  const maxLength = valueCol && valueCol.maxLength ? valueCol.maxLength : maxLengthDefault;

    const formatDateOnlyBR = (value) => {
        if (!value) return '';

        const datePart = value.toString().substring(0, 10);
        const [year, month, day] = datePart.split('-');

        if (!year || !month || !day) {
            return value;
        }

        return `${day}/${month}/${year}`;
    };

    if (typeof valueCol !== "object" || !valueCol) {
    TextCol = lodashTruncate(valueCol, maxLength);
  } else {
    propriedade = {
      onClick: (event) => {
        if (typeof valueCol.onClick === 'function') {
          valueCol.onClick(event);
        };
      },
      className: valueCol && valueCol.className ? valueCol.className : "",
    };

    if (valueCol.checkbox !== undefined) {
      TextCol = <ColCheckBox {...valueCol.checkbox} />;
    } else if (valueCol.type === 'data' && valueCol.text) {
      //TextCol = <DateLabel date={new Date(valueCol.text)} />;
      TextCol = formatDateOnlyBR(valueCol.text);
    } else if (valueCol.type === 'datehour' && valueCol.text) {
      TextCol = <DateHourLabel date={new Date(valueCol.text)} />;
    } else if (valueCol.type === 'statusConciliacao') {

        let colorComercial = '';
        if(valueCol.text[0] === '0') {
          colorComercial = '' 
        } else if (valueCol.text[0] === '2') {
          colorComercial = 'green'
        } else if (valueCol.text[0] === '3') {
          colorComercial = 'red'
        }

        let colorFiscal = '';
        if(valueCol.text[1] === '0') {
          colorFiscal = '' 
        } else if (valueCol.text[1] === '2') {
          colorFiscal = 'green'
        } else if (valueCol.text[1] === '3') {
          colorFiscal = 'red'
        } else if (valueCol.text[1] === '6') {
            colorFiscal = 'cornflowerblue'
        }

        TextCol = <span><StatusConciliation colorComercial={colorComercial} colorFiscal={colorFiscal} /></span>

      } else if (typeof valueCol.text !== 'string') {
        TextCol = valueCol.text;  
      } else {
      TextCol = lodashTruncate(valueCol.text, maxLength);

      if (valueCol.tooltip || valueCol.text.length >= maxLength) {
        TextCol = 
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip>
                {valueCol.tooltip ? valueCol.tooltip : valueCol.text}
              </Tooltip>
          }>
            <span> {TextCol} </span>
          </OverlayTrigger>
      }
    }

    if (typeof valueCol.onClick === 'function') {
      TextCol = <span>{TextCol}</span>
      propriedade = {...propriedade, className: 'text-link ' + propriedade.className }
    }
  }
  
  const newPropriedade = { ...propriedade, className: "bg-color-secondary py-1 text-2 item-list-body-border " + propriedade.className }
  return <td {...newPropriedade}>{TextCol}</td>
}

export default ItemCell;